

import React, { useEffect, useState } from 'react';
import loadable from "@loadable/component";


import { GetAllTenants, GetAllUsersData, genericmessage, notifymessages, genericmessagepushnotification, getAllArea } from '../../../services/CommonService';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';


import { Row, Col, Card } from "react-bootstrap";
import pMinDelay from 'p-min-delay';
//import CollegeChart from './CollegeChart';


const ApexBar2 = loadable(() => pMinDelay(import("./Bar2"), 1000));
const ApexBar3 = loadable(() => pMinDelay(import("./Bar3"), 1000));

const CollegeChart = loadable(() => pMinDelay(import("./CollegeChart"), 2000));
const CountReport = loadable(() => pMinDelay(import("./Svasthaa/CountReport"), 2000));

const TenantUsers = loadable(() => pMinDelay(import("./TenantUsers"), 2000));
const CourseEnrollment = loadable(() => pMinDelay(import("./CourseEnrollment"), 2000));
const AssessmentResult = loadable(() => pMinDelay(import("./AssessmentResult"), 2000));


const Home2 = () => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [value, setValue] = useState('');
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ size: [] }],
            [{ font: [] }],
            [{ align: ["right", "center", "justify"] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            [{ color: ["red", "#785412"] }],
            [{ background: ["red", "#785412"] }]
        ]
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "color",
        "image",
        "background",
        "align",
        "size",
        "font"
    ];
    const [tenantlist, setTenantList] = useState([]);
    const [tenantid, setTenantId] = useState(null);
    const [smscontent, setSmsContent] = useState(null);
    const [introcontent, setIntroContent] = useState(null);
    const [isAdmin, setIsAdmin] = useState(null);
    const [role, setRole] = useState(null);
    const [area, setArea] = useState([])
    const [areaModel, setAreaModel] = useState(false)
    useEffect(() => {
        //getBanner();
        getTenants();
        getArea()

    }, []);

    const getTenants = async () => {
        const constuserdetails = await JSON.parse(localStorage.getItem('userDetails'));
        if (constuserdetails != null) {
            setRole(constuserdetails.roles[0]);
            if (constuserdetails.roles[0] == 'ROLE_ADMIN') {

                setIsAdmin(true);
                const Response = await GetAllTenants({ pageno: -1, status: 'Active' })
                setTenantList(Response.data);

            } else {
                const Response = await GetAllTenants({ pageno: -1, status: 'Active', query: { tenantid: constuserdetails.user.tenantid } })
                setIsAdmin(false);
                setTenantList(Response.data);
            }
        }
    }

    const getArea = async () => {
        const constuserdetails = await JSON.parse(localStorage.getItem('userDetails'));
        if (constuserdetails.roles[0] == 'ROLE_COLLEGE_ADMIN') {
            const Response = await getAllArea({ pageno: "-1", status: 'Active', query: { tenantid: constuserdetails.user.tenantid, _id: constuserdetails.user.subapplicationid } })
            setArea(Response.data)
            setAreaModel(true)
        }

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTenantId(value);

    }
    const [tenantsmsid, setTenantSmsID] = useState(null);
    const [smstext, setSMStext] = useState(null);
    const [clgsmsid, setClgSmsid] = useState(null)

    const handleChangeSMS = (e) => {
        const { name, value } = e.target;
        if (name == "tenantsmsid") {
            setTenantSmsID(value);
        }
        if (name == "clgsmsid") {
            setClgSmsid(value)
        }

    }

    const sendSMS = async () => {
        if (tenantsmsid == null) {
            notifyTopFullWidth("Please choose tenant");
        } else if (smstext == null) {
            notifyTopFullWidth("Please enter smstext");
        }else if (clgsmsid == null) {
            notifyTopFullWidth("Please choose college");
        }
        else {
            const reqdata = {
                subapplicationid: clgsmsid,
                tenantid: tenantsmsid,
                message: smstext,
                reqtype: 'SMS'

            }

            const resData = await genericmessage(reqdata);
            if (resData.message == 'SUCCESS') {
                notifyTopFullWidth("SMS send successfully ");
                setSMStext(null)
            } else {
                notifyTopFullWidth("Failed to notify");
            }

        }
    }


    const [tenantpushid, setTenantpushID] = useState(null);
    const [subapppushid, setSubapppushID] = useState(null);
    const [pushtext, setpushtext] = useState(null);
    const [pushsubject, setPushsubject] = useState(null);

    const handleChangePush = (e) => {
        const { name, value } = e.target;
        if (name == "tenantpushid") {
            setTenantpushID(value);
        }
        if(name=="subapppushid"){
            setSubapppushID(value)
        }

    }

    const sendPushnotification = async () => {
        if (tenantpushid == null) {
            notifyTopFullWidth("Please choose tenant");
        } else if (pushtext == null) {
            notifyTopFullWidth("Please enter text");
        }
        else if (pushsubject == null) {
            notifyTopFullWidth("Please title");
        }
        else if (subapppushid == null) {
            notifyTopFullWidth("Please choose college");
        }
        else {
            const reqdata = {
                tenantid: tenantpushid,
                message: pushtext,
                title: pushsubject,
                reqtype: 'NOTIFICATIONS',
                subapplicationid:subapppushid

            }

            const resData = await genericmessage(reqdata);
            if (resData.message == 'SUCCESS') {
                notifyTopFullWidth("push notification successful ");
                setpushtext(null)
            } else {
                notifyTopFullWidth("Failed to notify");
            }

        }
    }

    const [tenantemailid, setTenantemailID] = useState(null);
    const [emailsubject, setEmailSubject] = useState(null);
    const [subappemail,setSubappEmail]=useState(null)

    const handleChangeEmail = (e) => {
        const { name, value } = e.target;
        if(name=="tenantemailid"){
        setTenantemailID(value);
        }
        if(name=='subappemail'){
            setSubappEmail(value)
        }

    }

    const sendEmail = async () => {
        if (tenantemailid == null) {
            notifyTopFullWidth("Please choose tenant");
        } else if (value == '') {
            notifyTopFullWidth("Please enter text");
        } else if (subappemail == null) {
            notifyTopFullWidth("Please choose college");
        }
        
        else {
            const reqdata = {
                tenantid: tenantemailid,
                message: value,
                reqtype: 'EMAIL',
                subject: emailsubject,
                subapplicationid:subappemail

            }

            const resData = await genericmessage(reqdata);
            if (resData.message == 'SUCCESS') {
                notifyTopFullWidth("Email sent successfully ");
                console.log("resData",resData);
            } else {
                notifyTopFullWidth("Failed to notify");
            }

        }
    }


    const handleProcedureContentChange = (content, delta, source, editor) => {
        setValue(content);
        //let has_attribues = delta.ops[1].attributes || "";
        //console.log(has_attribues);
        //const cursorPosition = e.quill.getSelection().index;
        // this.quill.insertText(cursorPosition, "★");
        //this.quill.setSelection(cursorPosition + 1);
    };


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <CountReport tenantid={tenantlist?.tenantid} role={role} />

            <CollegeChart tenantid={tenantlist?.tenantid} role={role} tenantlist={tenantlist} />

            <TenantUsers tenantid={tenantlist?.tenantid} role={role} tenantlist={tenantlist} />

            <CourseEnrollment tenantid={tenantlist?.tenantid} role={role} tenantlist={tenantlist} />

            <AssessmentResult tenantid={tenantlist?.tenantid} role={role} tenantlist={tenantlist} />



            {/* <DoctorDetails/> */}

            {/* <Patients/> */}

            <div className="col-xl-12">
                <div className="card">
                    <div className="card-header d-sm-flex d-block border-0">
                        <div className="me-auto mb-sm-0 mb-4">
                            <h4 className="fs-20 text-black font-w700">Send SMS</h4>



                        </div>
                        <div className="col-xl-6 col-lg-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className="basic-form">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="form-group mb-3 col-md-6">
                                                    <label>Tenant</label>
                                                    <select className="form-control" name="tenantsmsid"
                                                        value={tenantsmsid} onChange={handleChangeSMS}>
                                                        <option value=''>Select Tenant</option>
                                                        {tenantlist?.map(item => (
                                                            <option
                                                                key={item.tenantid}
                                                                value={item.tenantid}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {areaModel && <div className="form-group mb-3 col-md-6">
                                                    <label>College</label>
                                                    <select className="form-control" name="clgsmsid"
                                                        value={clgsmsid} onChange={handleChangeSMS}>
                                                        <option value=''>Select College</option>
                                                        {area?.map(item => (
                                                            <option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>}

                                                <div className="form-group mb-3 col-md-12">
                                                    <label>SMS Message</label>
                                                    <textarea
                                                        rows={3}
                                                        className="form-control"
                                                        name="smstext"
                                                        placeholder="message"
                                                        id="comment"
                                                        onChange={(e) => setSMStext(e.target.value)}
                                                        value={smstext}
                                                    />
                                                </div>


                                            </div>

                                            <button type="submit" onClick={sendSMS} className="btn btn-primary">
                                                Send Now
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-header d-sm-flex d-block border-0">
                        <div className="me-auto mb-sm-0 mb-4">
                            <h4 className="fs-20 text-black font-w700">Push Notifications</h4>



                        </div>
                        <div className="col-xl-6 col-lg-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className="basic-form">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="form-group mb-3 col-md-6">
                                                    <label>Tenant</label>
                                                    <select className="form-control" name="tenantpushid"
                                                        value={tenantpushid} onChange={handleChangePush}>
                                                        <option value=''>Select Tenant</option>
                                                        {tenantlist.map(item => (
                                                            <option
                                                                key={item.tenantid}
                                                                value={item.tenantid}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {areaModel && <div className="form-group mb-3 col-md-6">
                                                    <label>College</label>
                                                    <select className="form-control" name="subapppushid"
                                                        value={subapppushid} onChange={handleChangePush}>
                                                        <option value=''>Select College</option>
                                                        {area?.map(item => (
                                                            <option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>}

                                                <div className="form-group mb-3 col-md-6">
                                                    <label>Message Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Message Title"
                                                        name={pushsubject}
                                                        value={pushsubject}
                                                        onChange={(e) => setPushsubject(e.target.value)}
                                                    />
                                                </div>

                                                <div className="form-group mb-3 col-md-12">
                                                    <label>Push Message</label>
                                                    <textarea
                                                        rows={3}
                                                        className="form-control"
                                                        name="pushtext"
                                                        placeholder="message"
                                                        id="comment"
                                                        onChange={(e) => setpushtext(e.target.value)}
                                                        value={pushtext}
                                                    />
                                                </div>

                                            </div>

                                            <button type="submit" onClick={sendPushnotification} className="btn btn-primary">
                                                Send Now!!
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
            </div>

            <div className="col-xl-12">
                <div className="card">
                    <div className="card-header d-sm-flex d-block border-0">
                        <div className="me-auto mb-sm-0 mb-4">
                            <h4 className="fs-20 text-black font-w700">Send Email</h4>



                        </div>
                        <div className="col-xl-6 col-lg-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className="basic-form">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="form-group mb-3 col-md-6">
                                                    <label>Tenant</label>
                                                    <select className="form-control" name="tenantemailid"
                                                        value={tenantemailid} onChange={handleChangeEmail}>
                                                        <option value=''>Select Tenant</option>
                                                        {tenantlist.map(item => (
                                                            <option
                                                                key={item.tenantid}
                                                                value={item.tenantid}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {areaModel && <div className="form-group mb-3 col-md-6">
                                                    <label>College</label>
                                                    <select className="form-control" name="subappemail"
                                                        value={subappemail} onChange={handleChangeEmail}>
                                                        <option value=''>Select College</option>
                                                        {area?.map(item => (
                                                            <option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>}
                                                <div className="form-group mb-3 col-md-6">
                                                    <label>Subject</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Email subject"
                                                        name={emailsubject}
                                                        value={emailsubject}
                                                        onChange={(e) => setEmailSubject(e.target.value)}
                                                    />
                                                </div>

                                                <div className="form-group mb-3 col-md-12">
                                                    <label>Email Message</label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        modules={modules}
                                                        formats={formats}
                                                        value={value}
                                                        onChange={handleProcedureContentChange}
                                                    />
                                                </div>

                                            </div>

                                            <button type="submit" onClick={sendEmail} className="btn btn-primary">
                                                Send Now
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
            </div>


        </>
    )



}
export default Home2